// @import
import { ensureProps } from "@src/js/lib/ensure";
import Alpine from "alpinejs";
import { isYouTubeProvider } from "vidstack";

Alpine.directive("hero-video", async (element, { expression }, { cleanup }) => {
  const dom = {
    player: element.querySelector("media-player"),
  };

  const hasPlayer = ensureProps(dom, "player");
  let isAutoplayMode = element.hasAttribute("data-autoplay");
  let provider;
  let isYoutube = false;

  dom.player?.addEventListener("provider-change", (event) => {
    provider = event.detail;
    if (isYouTubeProvider(provider)) {
      provider.cookies = true;
      isYoutube = true;
    }
  });

  if (!hasPlayer) {
    console.warn("No media player found in hero video component");
    return;
  }

  /**
   * Autoplay mode :
   * The video start but in mute mode, informations are displayed
   * When play is clicked, hide infos unmute and seek at 0
   *
   * Non autoplay mode :
   * The video is paused, informations are displayed
   * When play is clicked, hide infos and play the video
   **/

  if (isAutoplayMode) {
    dom.player.subscribe(({ canPlay }) => {
      if (canPlay) {
        dom.player.play();
      }
    });
  }

  const togglePlay = () => {
    const isPlaying = dom.player?.state.playing;
    // Autoplay mode :
    // - unmute
    // - seek to 0
    // - revert to default behaviour
    if (isAutoplayMode) {
      dom.player.muted = false;
      if (isPlaying) {
        if (isYoutube) {
          // See https://github.com/vidstack/player/pull/1722
          provider.postMessage({
            event: "command",
            func: "seekTo",
            args: [0, true],
          });
        } else {
          dom.player.currentTime = 0;
        }
      } else {
        // Force unmuted before start
        dom.player.removeAttribute("data-muted");
      }
      element.classList.add("c-hero-video--playing");
      isAutoplayMode = false;
    } else {
      // Handle play/pause
      if (isPlaying) {
        dom.player.pause();
        element.classList.remove("c-hero-video--playing");
      } else {
        dom.player.subscribe(({ canPlay }) => {
          canPlay && dom.player.play();
          element.classList.add("c-hero-video--playing");
        });
      }
    }
  };

  element.addEventListener("click", togglePlay);

  cleanup(() => {
    element.removeEventListener("click", togglePlay);
  });
});
